import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';

import store from './redux/store';
import { history } from './router';
import Router from './router';
import { initAnalytics, trackPageView, trackUserId } from 'utils/analytics';
import 'translation/i18n';

import './index.scss';

initAnalytics();
// Before the first page view, so a returning client's entry view carries their id rather
// than waiting for fetchUser to resolve.
trackUserId(store);
// history.listen only fires on later navigation, so the view that opened the app has to
// be reported here or the entry page is missing from every session.
trackPageView(window.location.pathname + window.location.search);

const Root = () => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Router />
    </ConnectedRouter>
  </Provider>
);

ReactDOM.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
  document.getElementById('root'),
);
